const percentToDecimal = (percent) => (percent / 100).toFixed(3);
const decimalToPercent = (decimal) => parseFloat(decimal) * 100;

class Photo {
  constructor(attrs) {
    this.attrs = attrs;

    this.id = attrs.id;
    this.public_id = attrs.public_id;
    this.version = attrs.version;
    this.width = attrs.width;
    this.height = attrs.height;
    this.transformation = attrs.transformation || {};

    this.crop = this.parseCropFromTransformation(this.transformation);
    this.angle = this.transformation.angle;
  }

  copy() {
    return new Photo(this.attrsWithUpdates);
  }

  get attrsWithUpdates() {
    return Object.assign(this.attrs, {
      transformation: this.userTransformation,
    });
  }

  // Convert our db representation of transformations (in decimals)
  // to crop parameters in percentages
  parseCropFromTransformation(transform) {
    return {
      width: decimalToPercent(transform.width),
      height: decimalToPercent(transform.height),
      x: decimalToPercent(transform.x),
      y: decimalToPercent(transform.y),
    };
  }

  get thumbUrl() {
    const transformations = this.baseTransformations;
    Object.assign(transformations, {
      crop: 'thumb',
      gravity: 'south',
      width: 96,
      height: 96,
    });

    transformations.transformation = this.userTransformation;

    return this.signedUrl(this.public_id, transformations);
  }

  get fullUrl() {
    const transformations = this.baseTransformations;
    Object.assign(transformations, this.limitSizeTransformation);

    transformations.transformation = this.userTransformation;

    return this.signedUrl(this.public_id, transformations);
  }

  get fullUrlWithoutCrop() {
    const transformations = this.baseTransformations;
    Object.assign(transformations, this.limitSizeTransformation);

    transformations.transformation = this.angleTransformation;

    return this.signedUrl(this.public_id, transformations);
  }

  get baseTransformations() {
    return {
      version: this.version,
      quality: 'auto:eco',
      flags: 'progressive',
      angle: 'exif',
      format: 'jpg',
    };
  }

  get limitSizeTransformation() {
    return {
      crop: 'limit',
      width: 600,
      height: 600,
    };
  }

  get userTransformation() {
    return Object.assign(this.cropTransformation, this.angleTransformation);
  }

  get cropTransformation() {
    if (!this.isCropped) { return {}; }

    return {
      width: percentToDecimal(this.crop.width),
      height: percentToDecimal(this.crop.height),
      x: percentToDecimal(this.crop.x),
      y: percentToDecimal(this.crop.y),
      crop: 'crop',
    };
  }

  get angleTransformation() {
    if (!this.angle) { return {}; }

    return {
      angle: this.angle,
    };
  }

  rotate() {
    this.angle = this.angle || 0;

    this.angle = this.angle + 90;

    if (this.angle === 360) { this.angle = null; }

    // Because we've rotated the image, the crop coordinates
    // need to rotate as well.
    if (this.isCropped) {
      this.crop = {
        x: 100 - this.crop.height - this.crop.y,
        y: this.crop.x,
        width: this.crop.height,
        height: this.crop.width,
      };
    }
  }

  signedUrl(publicId, options) {
    const queryString = $.param({ options });
    return `/cloudinary/images/${publicId}?${queryString}`;
  }

  get isCropped() {
    return this.crop.width && !this.isCroppedToFullImage;
  }

  get isCroppedToFullImage() {
    return this.crop.width === 100 && this.crop.height === 100;
  }

  meetsMinimumDimension(dimension) {
    return this.width >= dimension && this.height >= dimension;
  }
}

module.exports = Photo;



// WEBPACK FOOTER //
// ./javascripts/components/photos/photo.js